import dayjs from 'dayjs'
import * as yup from 'yup'

export const schema = yup.object().shape({
  startDate: yup.date()
    .nullable()
    .transform((curr, orig) => (orig === '' ? null : curr))
    .required('Selecione o mês início'),
  endDate: yup.date()
    .nullable()
    .required('Selecione o mês fim')
    .transform((curr, orig) => (orig === '' ? null : curr))
    .min(
      yup.ref('startDate'),
      'O "Mês Fim" não pode ser menor do que o "Mês Início"',
    )
    .max(new Date(), 'O "Mês Fim" deve ser até o atual ou anterior')
    .test('rangeLimit', 'O intervalo entre "Mês Início" e "Mês Fim" deve ser no máximo de 12 meses', function (value) {
      const startDate = dayjs(this?.parent?.startDate)
      const endDate = dayjs(value)

      return (endDate.diff(startDate, 'month') < 12)
    }),
})
